import { ITableRecordData } from 'global.interfaces';

export const getRequestString = (
  api: string | ((data: ITableRecordData) => string),
  data: ITableRecordData,
  queryStringParam?: string,
): string => {
  const { actionKey = 'id' } = data;

  if (queryStringParam) {
    return `${api}?${queryStringParam}=${data[actionKey]}`;
  } else {
    return typeof api === 'function'
      ? api(data)
      : `${api}${api.toString().indexOf('?') === -1 ? '?' : '&'}${actionKey}=${data[actionKey]}`;
  }
};
